import { ITable } from "api/rpc/facilityAdmin/tables/tables";
import { ICart, ICartLineItem } from "./models/cart";
import { ICustomer } from "./models/customer";

interface IRegisterTab {
  title: string;
  cart: ICart;
  customer?: ICustomer;
}

export interface ICartState {
  isLoaded: boolean;
  error?: any;
  cart: ICart;
  token: string;
  line_items: ICartLineItem[];
  line_item_count: number;
  tabCarts: ICart[];
  activeTable: ITable;
  tables: Array<ITable>;
  registerTabs: IRegisterTab[];
}

export interface ICartAction {
  type: string;
  payload: Partial<ICartState>;
}

const initialState: ICartState = {
  isLoaded: false,
  error: null,
  cart: null,
  token: null,
  line_items: null,
  line_item_count: 0,
  tabCarts: null,
  activeTable: null,
  tables: null,
  registerTabs: [],
};

export default function CartReducer(state = initialState, action: ICartAction) {
  switch (action.type) {
    case "cart.update":
      return {
        ...state,
        ...action.payload,
      };
    case "cart.clear":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
